
import { logger } from './logger';

/**
 * Phase 12: Monitoring & Observability
 * Simulates Sentry Error Tracking and Datadog/New Relic APM metrics.
 */

interface Metric {
  name: string;
  value: number;
  timestamp: number;
  tags?: Record<string, string>;
}

const metrics: Metric[] = [];
const errors: any[] = [];
const startTime = Date.now();

export const monitoring = {
  /**
   * Simulates Sentry.captureException
   */
  captureException: (error: any, context?: any) => {
    errors.push({ error, context, timestamp: Date.now() });
    logger.error(`Exception captured: ${error.message || error}`, { error, context });
    
    // In a real app, this would POST to Sentry's DSN
    if (Math.random() > 0.8) {
       console.log("Sentry: Event sent to ingest.sentry.io");
    }
  },

  /**
   * Simulates APM Metric recording
   */
  recordMetric: (name: string, value: number, tags?: Record<string, string>) => {
    metrics.push({ name, value, timestamp: Date.now(), tags });
    if (metrics.length > 500) metrics.shift();
  },

  /**
   * Gets aggregated metrics for the dashboard
   */
  getPerformanceStats: () => {
    const apiLatencies = metrics.filter(m => m.name === 'api_latency');
    const avgLatency = apiLatencies.length > 0 
      ? apiLatencies.reduce((acc, m) => acc + m.value, 0) / apiLatencies.length 
      : 0;
      
    const errorCount = metrics.filter(m => m.name === 'error_count').length;
    const requestCount = metrics.filter(m => m.name === 'api_request').length;

    return {
      avgLatency,
      errorRate: requestCount > 0 ? (errorCount / requestCount) * 100 : 0,
      uptimeSeconds: Math.floor((Date.now() - startTime) / 1000),
      requestsPerMinute: Math.floor((requestCount / Math.max(1, (Date.now() - startTime) / 60000)))
    };
  }
};
